import { render, staticRenderFns } from "./List.vue?vue&type=template&id=ef8701d0&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=ef8701d0&lang=scss&scoped=true&"
import style1 from "./List.vue?vue&type=style&index=1&id=ef8701d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8701d0",
  null
  
)

export default component.exports